type FieldErrorProps = {
  id: string;
  messages: string[] | undefined;
};

function FieldError({ id, messages }: FieldErrorProps) {
  if (!messages?.length) {
    return null;
  }

  return (
    <p className="text-error text-sm" id={id} role="alert">
      {messages[0]}
    </p>
  );
}

export { FieldError };
